import type {
  ContactOrderPlanningCreateOperationResult,
  ContactOrderPlanningSubmissionResult,
} from "../../../../../../../_logic/contact-orders-contract"
import type { ContactOrderCreateIntent } from "../../../../../create-contact-orders-contract"

export const projectContactOrderSubmissionResult = <TCommitReceipt>(
  intent: Extract<ContactOrderCreateIntent, { kind: "commit" }>,
  operationResult: ContactOrderPlanningCreateOperationResult<TCommitReceipt>,
): Extract<ContactOrderPlanningSubmissionResult<TCommitReceipt>, { kind: "committed" }> => {
  const completedCount = operationResult.completedCount ?? operationResult.created.length
  const status =
    completedCount === 0 ? "empty" : operationResult.failedIds.size > 0 ? "partial" : "completed"

  return {
    kind: "committed",
    status,
    completedCount,
    workOrders: [...intent.workOrders],
    receipt: operationResult.receipt,
    removedEventIds: [...intent.removedEventIds],
    result: {
      result: operationResult.result,
      createdContactOrders: operationResult.contactOrders,
      scheduleEvents: operationResult.events,
      dirtyEventsPersisted: false,
    },
  }
}
